/**
 * schema Normalizr Schema
 */

import { schema as normalizrSchema } from 'normalizr';

const schema = new normalizrSchema.Entity('schemas');

export default schema;
